import {
   VideoConsultationReminderNotificationConfigurationQuery,
   VideoConsultationSetReminderNotificationCommand,
} from '@dreryk/egabinet-phone-notification-frontend-api';

import { refetchCqrsQuery, useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';

import { PatientPhoneNotificationVideoConsultationReminderToggleFormBean } from './PatientPhoneNotificationVideoConsultationReminderToggle.types';

export const useVideoConsultationReminderNotificationCommand = (): UseCqrsCommandResult<
   void,
   PatientPhoneNotificationVideoConsultationReminderToggleFormBean
> => {
   return useCqrsCommand(
      (parameters) => {
         const command = new VideoConsultationSetReminderNotificationCommand();
         command.enabled = parameters.notificationEnabled;
         return command;
      },
      {
         onSuccess: () => {
            refetchCqrsQuery(VideoConsultationReminderNotificationConfigurationQuery);
         },
      }
   );
};
